import {Component, OnInit, HostBinding} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {AnimationsMetaData} from '../_animations/animations.metadata';
import {Subscription} from 'rxjs/Subscription';
import {AnimationService} from '../_animations/animations.service';
import {RouteDirections, IRouteDirection} from '../_animations/route-directions.constant';

@Component({
  selector: 'app-education',
  providers: [AnimationService, RouteDirections],
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.css'],
  animations: [AnimationsMetaData]
})
export class EducationComponent implements OnInit {
  @HostBinding('@routing') routing;
  @HostBinding('style.display') display = 'block';
  private animationServiceEventsSubscription: Subscription;
  public routeDirections: IRouteDirection[];

  constructor(private Title: Title,
              private Meta: Meta,
              private animationService: AnimationService,
              routeDirections: RouteDirections) {
    this.routeDirections = routeDirections.education;
  }

  ngOnInit() {
    this.Title.setTitle('Education and Certifications | Alec Bertram');
    this.Meta.addTag({name: 'description', content: 'Certified Scrum Product Owner | Bachelor of Business Studies | Google Partner'});
    this.routing = this.animationService.animationDirection();
    this.animationServiceEventsSubscription = this.animationService.emitCurrentDirection
      .subscribe((direction: any) => this.routing = direction);
  }

  go(direction: string, url: string) {
    return this.animationService.routingService(direction, url);
  }
  pan($event, url: string) {
    return this.animationService.mobileRoutingSerivce($event, url);
  }
}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/education/education.component.ts